var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6463_18143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.498C18.6274 24.498 24 19.1255 24 12.498C24 5.87063 18.6274 0.498047 12 0.498047C5.37258 0.498047 0 5.87063 0 12.498C0 19.1255 5.37258 24.498 12 24.498Z",
    fill: "url(#paint0_linear_6463_18143)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.46884 13.0852C5.87164 12.3125 7.43754 11.6676 8.90064 11.0194C11.4177 9.95771 13.9448 8.91441 16.4974 7.94311C16.994 7.77761 17.8864 7.61581 17.9739 8.35181C17.9259 9.39361 17.7289 10.4293 17.5937 11.465C17.2506 13.7426 16.8539 16.0124 16.4672 18.2825C16.3339 19.0386 15.3867 19.4301 14.7806 18.9462C13.324 17.9622 11.8562 16.988 10.4182 15.9812C9.94724 15.5026 10.384 14.8152 10.8046 14.4734C12.0043 13.2911 13.2766 12.2866 14.4136 11.0432C14.7203 10.3026 13.8141 10.9268 13.5152 11.1181C11.8728 12.2499 10.2706 13.4508 8.53904 14.4455C7.65454 14.9324 6.62364 14.5163 5.73954 14.2445C4.94684 13.9164 3.78524 13.5857 4.46874 13.0853L4.46884 13.0852Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6463_18143",
    x1: 16.001,
    y1: 4.49885,
    x2: 10.001,
    y2: 18.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37AEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E96C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6463_18143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.498047)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.938e28ec2b36b3107ad9d4f2d5d6cbd4.svg";
export { ForwardRef as ReactComponent };